import styled from 'styled-components';

import { ErrorBanner } from 'ui/banner';
import { Link } from 'ui/links';
import { Body2, Body2Bold, spacing } from 'ui/theme';
import {
  MetaApprovalStatusDefinition,
  WhatsAppContentDefinition,
  WhatsAppTemplateRejectionReason,
} from 'modules/graphql';
import { SETTINGS_DISPLAY_CONTENT } from './constants';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';

const StyledErrorBanner = styled(ErrorBanner)`
  margin-top: ${spacing.plusHalf};

  * {
    color: inherit;
  }
`;

const SuggestionList = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
  margin-bottom: 0;
`;

const ListContent = styled.div`
display: inline;
align-items: top;
word-wrap: break-word;
  p {
    margin: 4px 0;
    white-space: pre;
    text-wrap:auto;
    display: inline;
  }
`;

export const WhatsAppStatusBanner = () => {
  const { liveTemplate } = useEditableFieldsContext();

  const metaApprovalStatus = ((liveTemplate?.mediumData || {}) as WhatsAppContentDefinition)
    .metaApprovalStatus;
  const rejectionReason = (liveTemplate.mediumData as WhatsAppContentDefinition).rejectionReason;
  const contentKey =
    metaApprovalStatus === MetaApprovalStatusDefinition.Rejected
      ? (rejectionReason ?? WhatsAppTemplateRejectionReason.UNKNOWN)
      : metaApprovalStatus;
  // @ts-ignore
  const bannerContent = SETTINGS_DISPLAY_CONTENT.statusBannerContent[contentKey];

  if (!bannerContent) return null;

  const { title, suggestions } = bannerContent;

  return (
    <StyledErrorBanner data-test={`whats-app-rejected-template-banner`} title={title}>
      <SuggestionList>
        {/* @ts-ignore */}
        {suggestions.map(({ primaryText, secondaryText, linkSuffix, linkPrefix }, i) => (
          <li key={`rejection-error-suggestion-${i}`}>
            <ListContent>
              {linkPrefix && (
                <>
                  <Link href={linkPrefix.href} target="_blank">
                    {linkPrefix.text}
                  </Link>
                </>
              )}
              {primaryText && <Body2Bold>{primaryText}</Body2Bold>}
              {secondaryText && <Body2>{secondaryText}</Body2>}
              {linkSuffix && (
                <>
                  <Link href={linkSuffix.href} target="_blank">
                    {linkSuffix.text}
                  </Link>
                  {'.'}
                </>
              )}
            </ListContent>
          </li>
        ))}
      </SuggestionList>
    </StyledErrorBanner>
  );
};
